
exports = module.exports = require('./lib/sizeof');